"use client"

import { useEffect, useState } from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function ModeToggle() {
  const { setTheme, resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Prevent SSR hydration mismatch for Radix dynamic menu IDs
  if (!mounted) {
    return (
      <Button variant="outline" size="icon" className="h-9 w-9 border-border bg-card">
        <Sun className="h-4 w-4 text-muted-foreground" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="h-9 w-9 border-border bg-card hover:cursor-pointer">
          <Sun className="h-4 w-4 scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90 text-amber-500" />
          <Moon className="absolute h-4 w-4 scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0 text-indigo-400" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-32">
        <DropdownMenuItem className="hover:cursor-pointer text-xs" onClick={() => setTheme("light")}>
          <Sun className="mr-2 h-3.5 w-3.5 text-amber-500" /> Light
        </DropdownMenuItem>
        <DropdownMenuItem className="hover:cursor-pointer text-xs" onClick={() => setTheme("dark")}>
          <Moon className="mr-2 h-3.5 w-3.5 text-indigo-400" /> Dark
        </DropdownMenuItem>
        <DropdownMenuItem className="hover:cursor-pointer text-xs" onClick={() => setTheme("system")}>
          System
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
